import type { ReactNode } from 'react'
import { Card, Statistic, theme } from 'antd'

export interface StatTile {
  key: string
  title: ReactNode
  value: string
  extra?: ReactNode
  danger?: boolean
}

export function StatTiles({ tiles }: { tiles: readonly StatTile[] }) {
  const { token } = theme.useToken()
  return (
    <div
      style={{
        display: 'grid',
        gap: token.margin,
        gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
        marginBottom: token.margin,
      }}
    >
      {tiles.map((tile) => (
        <Card key={tile.key} size="small" style={{ height: '100%' }}>
          <Statistic
            title={tile.title}
            value={tile.value}
            valueStyle={{ fontSize: token.fontSizeHeading4, ...(tile.danger ? { color: token.colorError } : {}) }}
          />
          {tile.extra}
        </Card>
      ))}
    </div>
  )
}
